import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { createAuthorizer } from '../authguards/casbin/enforcer';

type AuthorizedRouteProps = {
  action: 'read' | 'write' | 'edit' | 'delete' | 'export';
  resource: string;
  redirectTo?: string;
};

const AuthorizedRoute = ({
  action,
  resource,
  redirectTo = '/unauthorized',
}: AuthorizedRouteProps) => {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;

    const checkPermission = async () => {
      const roleInfo = JSON.parse(localStorage.getItem('roleInfo') || 'null');
      const roleName = roleInfo?.name;
      const projectId = localStorage.getItem('selectedProjectId');

      const rolesStr = localStorage.getItem('projectRoles');
      const projectRoles = rolesStr ? JSON.parse(rolesStr) : {};

      const role = projectRoles[projectId!] ?? roleName;
      const authorizer = createAuthorizer(role);

      const result = await authorizer.can(action, resource);

      if (mounted) setAllowed(result);
    };

    checkPermission();

    return () => {
      mounted = false;
    };
  }, [action, resource]);

  if (allowed === null) return null; // or spinner

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default AuthorizedRoute;
